import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, AlertBase as Alert, Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Message, Title } from 'src/core/components';
import { EditPageTitle, EditPageActions } from 'src/components';
import DetailRow from 'src/components/DetailRow';

import messages from './messages';
import { PlateWellsForm } from './components';
import './EditSequence.styles.scss';

const EditSequenceComponent = ({
  plateName,
  onChangeField,
  formState,
  onCancel,
  onSubmit,
  canSubmit,
  onPreview,
  validators,
  onBackClick,
  error,
  clearError,
  isInitialLoad,
  enableActionButtons
}) => (
  <div data-testid="edit-sequence-component">
    <EditPageTitle
      title={messages.editSequenceTitle}
      backButtonLabel={messages.editSequenceBackButtonLabel}
      onBackClick={onBackClick}
    />
    <div className="plate-readonly-details" data-testid="plate-readonly-details">
      <Title size="4" message={messages.plateDetailsTitle} font="medium" />
      <Spacer bottom="16" />
      <DetailRow label={messages.plateName} value={plateName} dots />
    </div>
    <Spacer bottom="40" />
    <Visible when={!isInitialLoad}>
      <PlateWellsForm
        {...{
          onChangeField,
          formState,
          onPreview,
          validators,
        }}
      />
      <Visible when={!!error?.id}>
        <Spacer top="40" />
        <Alert
          data-testid="dna-oligos-action-error"
          float
          white
          type="error"
          onClose={clearError}
        >
          <Message message={error} />
        </Alert>
      </Visible>
      <EditPageActions
        {...{
          onCancel,
          onSubmit,
          canSubmit,
          enableActionButtons
        }}
      />
    </Visible>
  </div>
);

EditSequenceComponent.propTypes = {
  plateName: PropTypes.string.isRequired,
  onChangeField: PropTypes.func.isRequired,
  formState: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  onPreview: PropTypes.func.isRequired,
  validators: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired,
  error: PropTypes.object,
  clearError: PropTypes.func.isRequired,
  isInitialLoad: PropTypes.bool,
  enableActionButtons: PropTypes.bool
};

export default EditSequenceComponent;
